// eslint-disable-next-line import/no-duplicates
import format from 'date-fns/format';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';
// eslint-disable-next-line import/no-duplicates
import set from 'date-fns/set';

import { declOfNum } from './declOfNum';
import { translations } from './localization';

export const getUnixTime = (time: number): number => time * 1000;
export const getFormattedDate = (time: number, template: string): string => {
	return format(getUnixTime(time), template, { locale: ru });
};
export const getSubscriptionDate = (time: number): string => getFormattedDate(time, 'dd.MM.yyyy');
export const getCreatedAtDate = (time: number, separator = '') =>
	getFormattedDate(time, `dd MMMM ${separator} HH:mm`)
		.toLowerCase();

export const getFormattedDateUTC = (dateString: number) => {
	const date = new Date(getUnixTime(dateString));

	return new Date(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds(),
	);
};

export const getSubscriptionDateUTC = (time: number): string => {
	return format(getFormattedDateUTC(time), 'dd.MM.yyyy');
};

export const getDayStartTime = (daysCount = 0, date: Date = new Date()): number => {
	return Number(set(date, {
		date: date.getDate() - daysCount,
		hours: 0,
		minutes: 0,
		seconds: 0,
		milliseconds: 0,
	})) / 1000;
};

export const getNormalizedTimestamp = (date: Date): number => Math.floor(Number(date) / 1000);

export const getLocalizedTime = (number: number) => {
	return {
		days: `${number} ${declOfNum(
			[
				translations.common('plural.day.0'),
				translations.common('plural.day.1'),
				translations.common('plural.day.2'),
			],
			number)
		}`,
		hours: `${number} ${declOfNum(
			[
				translations.common('plural.hour.0'),
				translations.common('plural.hour.1'),
				translations.common('plural.hour.2'),
			],
			number)
		}`,
		minutes: `${number} ${declOfNum(
			[
				translations.common('plural.minute.0'),
				translations.common('plural.minute.1'),
				translations.common('plural.minute.2'),
			],
			number)
		}`,
		seconds: `${number} ${declOfNum(
			[
				translations.common('plural.second.0'),
				translations.common('plural.second.1'),
				translations.common('plural.second.2'),
			],
			number)
		}`,
	};
};
